import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function LoadingBackdrop(props) {
  return (
    <div>
      <Backdrop
        sx={{ color: '#fff', opacity:'.7', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={props.open}
      >
        <CircularProgress style={{color:"magenta"}} /> <span style={{marginLeft:25}}>{props.bgtxt}</span>
      </Backdrop>
    </div>
  );
}